module.exports = __webpack_public_path__ + "static/media/time-management.1afe61b0.png";